export default __webpack_public_path__ + "static/media/Empty.4b29266f.svg";